import {Component, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Select} from 'primeng/select';
import {Textarea} from 'primeng/textarea';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {
  CustomerClient,
  TenantClient,
  UpdateCustomerRequestDto
} from '../../../api/api-client';
import {ActivatedRoute, Router} from '@angular/router';
import {FeedbackDataService} from '../../../services/feedback-data.service';
import {FeedbackData} from '../../../models/feedback-data';
import {Editor} from 'primeng/editor';
import {isFormControlInvalid} from '../../../util/form-control-invalid-checker';
import {twoFieldsOrValidator} from '../../../validators/two-fields-or.validator';
import {SubscriptionManager} from '../../../services/subscription-manager.service';

@Component({
  selector: 'app-edit-customer',
  imports: [
    Button,
    InputText,
    ReactiveFormsModule,
    Select,
    TranslationPipe,
    Editor
  ],
  providers: [SubscriptionManager],
  templateUrl: './edit-customer.component.html',
  styleUrl: './edit-customer.component.scss',
})
export class EditCustomerComponent implements OnInit {

  editCustomerForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    company: new FormControl(''),
    eMail: new FormControl(''),
    phoneNumber: new FormControl(''),
    country: new FormControl('', [Validators.required]),
    street: new FormControl('',),
    houseNumber: new FormControl('', Validators.pattern(String.raw`\d+\w*`)),
    postalCode: new FormControl('', [Validators.required, Validators.pattern('[0-9]{4,5}')]),
    city: new FormControl('', [Validators.required]),
    notes: new FormControl(''),
  });

  customerId!:string;
  countries: string[] = ["Österreich", "Deutschland"]
  submitButtonClicked:boolean=false;

  constructor(
    private readonly subscriptionManager:SubscriptionManager,
    private readonly customerService: CustomerClient,
    private readonly router: Router,
    private readonly route:ActivatedRoute,
    private readonly feedbackService: FeedbackDataService
  ) {
    this.subscriptionManager.call(
    this.route.paramMap,
      (paramMap => {
      this.customerId = paramMap.get('customerId') ?? "";
    })
    );
  }

  ngOnInit(): void {
    this.subscriptionManager.call(
    this.customerService.getCustomerById(this.customerId),
      (x => {
      const customer = x.result;
        this.editCustomerForm.setValue({
          firstName: customer.firstName,
          lastName: customer.lastName,
          company: customer.company??"",
          eMail: customer.eMail,
          phoneNumber: customer.phoneNumber,
          street: customer.street,
          houseNumber: customer.houseNumber,
          postalCode: customer.postalCode,
          city: customer.city,
          notes: customer.notes,
          country: customer.country
        });
    })
  );
    this.feedbackService.feedbackData=new FeedbackData();
    this.feedbackService.feedbackData.customerId=this.customerId;

    this.editCustomerForm.get("phoneNumber")?.setValidators([twoFieldsOrValidator(this.editCustomerForm,"eMail"),Validators.email])
    this.editCustomerForm.get("eMail")?.setValidators([twoFieldsOrValidator(this.editCustomerForm,"phoneNumber"), Validators.pattern('[- +()0-9]{6,}')])

    // Trigger validation when phoneNumber changes
    // emitEvent=false, because else endless loop between phoneNumber and eMail validators
    this.subscriptionManager.call(
    this.editCustomerForm.get("phoneNumber")?.valueChanges,
      (() => {
      this.editCustomerForm.get("eMail")?.updateValueAndValidity({ emitEvent: false });
    })
    );
    // Trigger validation when eMail changes
    this.subscriptionManager.call(
    this.editCustomerForm.get("eMail")?.valueChanges,
      (() => {
      this.editCustomerForm.get("phoneNumber")?.updateValueAndValidity({ emitEvent: false });
    })
    );
  }

  onSubmit() {
    this.submitButtonClicked = true;
    if (this.editCustomerForm.valid) {
      this.subscriptionManager.call(
      this.customerService.updateCustomer({
        id: this.customerId,
        firstName: this.editCustomerForm.value.firstName ?? "",
        lastName: this.editCustomerForm.value.lastName ?? "",
        company: this.editCustomerForm.value.company ?? "",
        eMail: this.editCustomerForm.value.eMail ?? "",
        phoneNumber: this.editCustomerForm.value.phoneNumber ?? "",
        street: this.editCustomerForm.value.street ?? "",
        houseNumber: this.editCustomerForm.value.houseNumber ?? "",
        postalCode: this.editCustomerForm.value.postalCode ?? "",
        city: this.editCustomerForm.value.city ?? "",
        country: this.editCustomerForm.value.country ?? "",
        notes: this.editCustomerForm.value.notes ?? "",
      } as unknown as UpdateCustomerRequestDto),
        (x => {
          this.router.navigate(['../loggedin/customer-detail/' + this.customerId],)
      })
      );
    }
  }


  protected abortEdit() {
    this.router.navigate(['../loggedin/customer-detail/' + this.customerId],)
  }

  protected readonly isFormControlInvalid = isFormControlInvalid;
}
